import React, { useEffect, useState } from "react";
import Select from "react-select";

//redux
import { connect, useSelector } from "react-redux";

//action
import { getAvatarFrame, getSvga } from "../store/AvatarFrame/action";
import { getBackground } from "../store/background/action";
import { getCategory } from "../store/giftCategory/action";
import { getGift } from "../store/gift/action";

const RewardTypeSelector = (props) => {
  const {
    rewardType,
    setRewardType,
    validity,
    setValidity,
    validityType,
    setValidityType,
    diamonds,
    setDiamonds,
    giftQuantity,
    setGiftQuantity,
    selectedFrame,
    setSelectedFrame,
    selectedSvga,
    setSelectedSvga,
    selectedBackground,
    setSelectedBackground,
    selectedGift,
    setSelectedGift,
    selectedGiftCategory,
    setSelectedGiftCategory,
    errors = {},
    showGiftCategory = true,
    showGiftQuantity = true,
    showValidity = true,
    showValidityType = true,
    showDiamonds = true,
    showRcoin = false,
    rcoins = 1,
    setRcoins = () => {},
  } = props;

  const { avatarFrame, svga } = useSelector((state) => state.avatarFrame);
  const { background } = useSelector((state) => state.background);
  const categories = useSelector((state) => state.giftCategory.giftCategory);
  const gift = useSelector((state) => state.gift.gift);

  const [avatarOptions, setAvatarOptions] = useState([]);
  const [svgaOptions, setSvgaOptions] = useState([]);
  const [backgroundOptions, setBackgroundOptions] = useState([]);
  const [giftOptions, setGiftOptions] = useState([]);
  const [giftCategoryOptions, setGiftCategoryOptions] = useState([]);

  useEffect(() => {
    props.getAvatarFrame("frame");
    props.getSvga();
    props.getBackground();
    props.getCategory();
  }, []);

  useEffect(() => {
    if (avatarFrame && avatarFrame.length > 0) {
      const options = avatarFrame.map((item, index) => ({
        value: item._id,
        label: item.name,
        image: item.imagePreview ? item.imagePreview : item.image,
        index: index,
      }));
      setAvatarOptions(options);
    }
  }, [avatarFrame]);

  useEffect(() => {
    if (gift && gift.length > 0) {
      const options = gift.map((item, index) => ({
        value: item._id,
        label: item.name,
        image: item.type === 2 ? item.imagePreview : item.image,
        index: index,
      }));
      setGiftOptions(options);
    }
  }, [gift]);

  useEffect(() => {
    if (categories && categories.length > 0) {
      const options = categories.map((item, index) => ({
        value: item._id,
        label: item.name,
        image: item.image,
        index: index,
      }));
      setGiftCategoryOptions(options);
      if (!selectedGiftCategory) {
        setSelectedGiftCategory(categories[0]?._id);
        props.getGift(categories[0]?._id);
      }
    }
  }, [categories]);

  useEffect(() => {
    if (selectedGiftCategory) {
      props.getGift(selectedGiftCategory);
    }
  }, [selectedGiftCategory]);

  useEffect(() => {
    if (background && background.length > 0) {
      const options = background.map((item, index) => ({
        value: item._id,
        label: item.name,
        image: item.image,
        index: index,
      }));
      setBackgroundOptions(options);
    }
  }, [background]);

  useEffect(() => {
    if (svga && svga.length > 0) {
      const options = svga.map((item, index) => ({
        value: item._id,
        label: item.name,
        image: item.imagePreview,
        index: index,
      }));
      setSvgaOptions(options);
    }
  }, [svga]);

  const handleRewardSelect = (selected) => {
    if (rewardType === "svga") {
      setSelectedSvga(selected);
    }
    if (rewardType === "frame") {
      setSelectedFrame(selected);
    }
    if (rewardType === "background") {
      setSelectedBackground(selected);
    }
    if (rewardType === "gift") {
      setSelectedGift(selected);
    }
  };

  return (
    <>
      <div className="row mt-3">
        <div className="mb-3 col-md-12">
          <label htmlFor="reward" className="form-label">
            Reward Type
          </label>
          <select
            className="form-select form-control"
            value={rewardType}
            onChange={(event) => setRewardType(event.target.value)}
          >
            <option value="frame">Avatar Frame</option>
            <option value="svga">Entrance Effect</option>
            <option value="background">Background</option>
            <option value="gift">Live Gift</option>
            <option value="diamond">Diamond</option>
            {showRcoin && <option value="rcoin">VCoin</option>}
          </select>
        </div>

        {showGiftCategory && (
          <div
            className="mb-3 col-md-12"
            style={{ display: rewardType === "gift" ? "block" : "none" }}
          >
            <label htmlFor="giftCategory" className="form-label">
              Gift Category
            </label>
            <select
              className="form-select form-control"
              aria-label="Default select example"
              value={selectedGiftCategory || ""}
              onChange={(e) => {
                setSelectedGiftCategory(e.target.value);
              }}
            >
              {giftCategoryOptions.map((category) => {
                return (
                  <option key={category.value} value={category.value}>
                    {category.label}
                  </option>
                );
              })}
            </select>
          </div>
        )}

        {showDiamonds && (
          <div
            className="col-md-12"
            style={{ display: rewardType === "diamond" ? "block" : "none" }}
          >
            <label className="form-label">Diamonds</label>
            <input
              value={diamonds}
              onChange={(e) => setDiamonds(e.target.value)}
              type="Number"
              className="form-control"
              id="diamonds"
            />
            {rewardType === "diamond" && !diamonds && (
              <div className="ml-2 mt-1">
                <div className="pl-1 text__left">
                  <span className="text-red">{errors.diamonds}</span>
                </div>
              </div>
            )}
          </div>
        )}
        {showRcoin && (
          <div
            className="col-md-12"
            style={{ display: rewardType === "rcoin" ? "block" : "none" }}
          >
            <label className="form-label">VCoins</label>
            <input
              value={rcoins}
              onChange={(e) => setRcoins(e.target.value)}
              type="Number"
              className="form-control"
            />
            {rewardType === "rcoin" && !rcoins && (
              <div className="ml-2 mt-1">
                <div className="pl-1 text__left">
                  <span className="text-red">VCoin amount is required.</span>
                </div>
              </div>
            )}
          </div>
        )}
      </div>

      <div className="row mt-2">
        <div className="col-md-12">
          <label className="form-label">
            {rewardType === "svga"
              ? "Entrance Effect"
              : rewardType === "frame"
                ? "Avatar Frame"
                : rewardType === "background"
                  ? "Background"
                  : rewardType === "gift"
                    ? "Gift"
                    : ""}
          </label>
          <Select
            options={
              rewardType === "svga"
                ? svgaOptions
                : rewardType === "frame"
                  ? avatarOptions
                  : rewardType === "background"
                    ? backgroundOptions
                    : rewardType === "gift"
                      ? giftOptions
                      : []
            }
            value={
              rewardType === "svga"
                ? selectedSvga
                : rewardType === "frame"
                  ? selectedFrame
                  : rewardType === "background"
                    ? selectedBackground
                    : selectedGift
            }
            onChange={(selected) => handleRewardSelect(selected)}
            formatOptionLabel={(option) => (
              <div style={{ display: "flex", flexDirection: "row" }}>
                <img
                  src={option.image}
                  style={{ width: 40, height: 40, marginRight: 10 }}
                  alt={option.label}
                />
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <span>{option.label}</span>
                  <span>ID: {option.value}</span>
                </div>
              </div>
            )}
            theme={(theme) => ({
              ...theme,
              borderRadius: 0,
              colors: {
                ...theme.colors,
                primary: "#e8538f",
                neutral0: "#1f1f2b",
                neutral80: "#fff",
                primary25: "#181821 ",
                primary50: "#cf779a",
              },
            })}
            styles={{
              control: (baseStyles, state) => ({
                ...baseStyles,
                borderColor: "#2d2d3f",
                borderRadius: 3,
                display: rewardType === "diamond" || rewardType === "rcoin" ? "none" : "flex",
              }),
            }}
          />
          {rewardType === "frame" && !selectedFrame && (
            <div className="ml-2 mt-1">
              <div className="pl-1 text__left">
                <span className="text-red">{errors.avatarFrame}</span>
              </div>
            </div>
          )}
          {rewardType === "svga" && !selectedSvga && (
            <div className="ml-2 mt-1">
              <div className="pl-1 text__left">
                <span className="text-red">{errors.entranceEffect}</span>
              </div>
            </div>
          )}
          {rewardType === "background" && !selectedBackground && (
            <div className="ml-2 mt-1">
              <div className="pl-1 text__left">
                <span className="text-red">{errors.background}</span>
              </div>
            </div>
          )}
          {rewardType === "gift" && !selectedGift && (
            <div className="ml-2 mt-1">
              <div className="pl-1 text__left">
                <span className="text-red">{errors.gift}</span>
              </div>
            </div>
          )}
        </div>

        {showGiftQuantity && (
          <div
            className="col-md-12 mt-3"
            style={{ display: rewardType === "gift" ? "block" : "none" }}
          >
            <label className="form-label">Gift Quantity</label>
            <input
              value={giftQuantity}
              onChange={(e) => setGiftQuantity(e.target.value)}
              type="Number"
              className="form-control"
              id="quantity"
            />
            {rewardType === "gift" && (!giftQuantity || giftQuantity <= 0) && (
              <div className="ml-2 mt-1">
                <div className="pl-1 text__left">
                  <span className="text-red">Gift quantity is required</span>
                </div>
              </div>
            )}
          </div>
        )}

        {showValidity && (
          <div
            className="col-md-12 mt-3"
            style={{
              display:
                rewardType === "diamond" || rewardType === "rcoin" || rewardType === "gift"
                  ? "none"
                  : "block",
            }}
          >
            <label className="form-label">Validity</label>
            <input
              value={validity}
              onChange={(e) => setValidity(e.target.value)}
              type="Number"
              className="form-control"
              id="validity"
            />
            {rewardType !== "diamond" && rewardType !== "rcoin" && rewardType !== "gift" && !validity && (
              <div className="ml-2 mt-1">
                <div className="pl-1 text__left">
                  <span className="text-red">{errors.validity}</span>
                </div>
              </div>
            )}
          </div>
        )}

        {showValidityType && (
          <div
            className="col-md-12 mt-3"
            style={{
              display:
                rewardType === "diamond" || rewardType === "rcoin" || rewardType === "gift"
                  ? "none"
                  : "block",
            }}
          >
            <label htmlFor="validityType" className="form-label">
              Validity Type
            </label>
            <select
              value={validityType}
              onChange={(e) => setValidityType(e.target.value)}
              className="form-select form-control"
              id="validityType"
            >
              <option value="day">Day</option>
              <option value="month">Month</option>
              <option value="year">Year</option>
            </select>
          </div>
        )}
      </div>
    </>
  );
};

export default connect(null, {
  getAvatarFrame,
  getSvga,
  getBackground,
  getCategory,
  getGift,
})(RewardTypeSelector);
